import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function Icon4K24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="4K">
            <path
                d="M12.003 14.094H11.067V15.3H9.33V14.094H6V12.933L8.826 9H10.671L8.106 12.681H9.384V11.61H11.067V12.681H12.003V14.094Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M15.1188 13.014L14.4528 13.725V15.3H12.6888V9H14.4528V11.619L16.8918 9H18.8538L16.2798 11.79L18.9888 15.3H16.9188L15.1188 13.014Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 5C0 3.89543 0.895431 3 2 3H22C23.1046 3 24 3.89543 24 5V19C24 20.1046 23.1046 21 22 21H2C0.89543 21 0 20.1046 0 19V5ZM2 5H22V19H2L2 5Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
